import { Dropdown, Icon } from '@ps/sports-ui-component-library';
import { ChevronMediumDown } from '@ps/sports-ui-component-library/icons/ChevronMediumDown';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import type { MeetingsQuickSwitcherData } from '@swf/generated/types/api/sports';
import { CardTitle } from '@swf/sports/components';

import FormattedRelativeDate from '../../../FormattedRelativeDate/FormattedRelativeDate';
import styles from '../../QuickSwitcher.scss';
import Meeting from '../../components/MeetingSwitcher/components/Meeting/Meeting';
import NextOff from '../../components/MeetingSwitcher/components/NextOff/NextOff';

import { TXTWCL_International, TXTWCL_UK_X_Ireland } from './Meetings.messages.json';

const headerMap = {
  ISP_I18N_UK_X_IRELAND: TXTWCL_UK_X_Ireland,
  ISP_I18N_INTERNATIONAL: TXTWCL_International
};

interface MeetingProps {
  title: string;
  quickSwitcherData: MeetingsQuickSwitcherData;
}
const Meetings: React.FC<MeetingProps> = ({ title, quickSwitcherData }) => {
  const dropdownTitle = (
    <>
      <FormattedRelativeDate
        date={new Date(quickSwitcherData.races[quickSwitcherData.firstOffRaceId].startTime)}
      />{' '}
      - <Translation {...headerMap[quickSwitcherData.header]} />
    </>
  );

  return quickSwitcherData.groups.length > 1 ? (
    <Dropdown
      title={dropdownTitle}
      verticalOffset="XXS"
      triggerEl={({ arrowRef, ...props }) => (
        <CardTitle title={title} {...props}>
          <Icon ref={arrowRef} icon={ChevronMediumDown} size="sm" className={styles.icon} />
        </CardTitle>
      )}
      overlay
    >
      <NextOff />
      {quickSwitcherData.groups.map((raceIds) => (
        <Meeting key={raceIds[0]} raceIds={raceIds} />
      ))}
    </Dropdown>
  ) : (
    <CardTitle title={title} />
  );
};

export default Meetings;
